module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"HeaderMain":{"logoTitle":"{website}","mobileMenuButton":{"ariaLabelClose":"Zavřít menu","ariaLabelOpen":"Otevřít menu","text":"Menu"}}},"en":{"HeaderMain":{"logoTitle":"{website}","mobileMenuButton":{"ariaLabelClose":"Close menu","ariaLabelOpen":"Open menu","text":"Menu in the footer"}}}}')
  delete Component.options._Ctor
}
